<template>
  <RevDrawer
    :has-padding="false"
    :name="MODAL_NAMES.SELLER_DETAILS"
    :title="i18n(translations.title)"
  >
    <template #body>
      <SellerDetailsModalBody :listing-id :product-id />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './SellerDetailsModal.translations'
import SellerDetailsModalBody from './components/SellerDetailsModalBody/SellerDetailsModalBody.vue'

defineProps<{
  listingId?: string | null
}>()

const i18n = useI18n()
const { productId } = useUrlParams()
</script>
